export default {
	'{days}天后': '{days}天後',
	今日到期: '今日到期',
	'已过期{days}天': '已過期{days}天',
}
